<template>
  <div class="mb-5">
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row>
      <v-col cols="12" md="4" xs="12">
        <v-card outlined>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Cursos creados
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="d-flex">
                <v-checkbox v-model="selectAll" class="ma-0 pa-0" @change="selectAllCheckboxes" label="Seleccionar todos"
                  color="success" />
                <v-spacer />
                <ButtonComp :disabled="!cursosSeleccionados.length" @click="seleccCurso" text-button="Agregar"
                  icon-but="fas fa-plus" />

              </v-col>

              <v-col cols="12" sm="12" md="12" class="d-flex justify-center" v-for="item in Cursos" :key="item.id">
                <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color_nivel }">
                  <v-list-item>
                    <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                      <v-icon dark>{{ item.icono_curso }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-0">
                      <span class="mb-1 font-weight-bold black--text">{{
                        item.desc_curso
                      }}</span>
                      <v-list-item-title class="caption">Área: {{ item.desc_area }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text :style="{ background: item.color_nivel }" id="text">{{ item.nivel }} - {{ item.grado
                  }}</v-card-text>

                  <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-checkbox class="ma-0 pa-0" v-model="cursosSeleccionados" :value="item.id" color="success"
                      :key="item.id" hide-details>
                    </v-checkbox>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12" v-if="Cursos.length < 1">
                <v-card outlined>
                  <v-card-text style="height: 240px" class="d-flex text-center justify-center align-center">
                    No tiene más cursos por asignar
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>



          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" xs="12">
        <v-card outlined>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Cursos del colegio
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <div class="d-flex">
                <v-container>
                  <v-row wrap class="overflow-y-auto">
                    <v-col cols="12" sm="12" md="6" class="d-flex justify-center" v-for="item in CursosAdmin"
                      :key="item.id">
                      <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color_nivel }">
                        <v-list-item>
                          <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                            <v-icon dark>{{ item.icono_curso }}</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content class="py-0">
                            <span class="mb-1 font-weight-bold black--text">{{
                              item.desc_curso
                            }}</span>
                            <v-list-item-title class="caption">Área: {{ item.desc_area }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-card-text :style="{ background: item.color_nivel }" id="text">{{ item.nivel }} - {{ item.grado
                        }}</v-card-text>

                        <v-card-actions>
                          <v-col cols="12" md="" class="pb-md-0 pt-1 pb-xs-3 d-flex justify-end">
                            <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="showmodalDelete(item.id)"
                              delete-button tooltipText="Eliminar cursos" />

                          </v-col>
                        </v-card-actions>
                      </v-card>
                    </v-col>

                    <v-col cols="12" v-if="CursosAdmin.length < 1">
                      <v-card outlined>
                        <v-card-text style="height: 240px" class="d-flex text-center justify-center align-center">
                          Aún no has agregado cursos al colegio, dar clic en el botón agregar
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>


    <!-- modal agregar nivel a mantenimiento --->
    <ComunDialogComp v-model="dialog" Confirmdialog titleWindow="Confirmar" @close-modal="dialog = false"
      @confirm-item="importCurso" @cancel-item="dialog = false">
      <template v-slot:body>
        <h3 class="text-center">¿Está seguro de agregar los cursos seleccionados al colegio?</h3>
        <br />
        <span>Cursos seleccionados:</span>
        <ul>
          <li v-for="(curso, index) in dataCursosSeleccionados" :key="index">
            {{ curso.desc_curso }} - {{ curso.grado }}
          </li>
        </ul>
      </template>
    </ComunDialogComp>

    <!--------fin modal-->

    <confirm @aceptar="deleteCurso" @cancelar="clear_confirm" titleWindow="Eliminar curso" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>



<script>
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';

export default {
  name: "cursos",
  components: {
    ButtonComp,
    ComunDialogComp
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 16, id_modulo: 6 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    Cursos: [],
    mostrarMensaje: false,
    selectAll: false,

    CursosAdmin: [],
    mostrarMensaje2: false,

    confirm: {
      id: 0,
      title: "",
      active: false,
    },
    //modal importar curso a colegio
    dialog: false,
    nombre_curso: "",
    color_curso: "",
    icono_curso: "",
    grado_curso: "",
    color_nivel: "",
    nivel: "",

    // edit cursos
    editedCursos: {
      id_curso: 0,
      id_area: 0,
      id_colegio: sessionStorage.id_colegio,
      id_usuario: sessionStorage.id,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_grado: 0,
    },

    // Cursos
    defaultCursos: {
      id_curso: 0,
      id_area: 0,
      id_colegio: sessionStorage.id_colegio,
      id_usuario: sessionStorage.id,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_grado: 0,
    },

    cursosSeleccionados: [], //cursos seleccionadas para agregar
    isSaving: false
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    dataCursosSeleccionados() {
      return this.Cursos.filter(e => this.cursosSeleccionados.includes(e.id))
    }
  },

  mounted() {
    this.getAllCursosMantenimiento(), this.getAllCursosAdministrativo();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    selectAllCheckboxes() {
      if (this.selectAll) {
        // Si el checkbox "Seleccionar Todos" está marcado, seleccionar todos los niveles
        this.cursosSeleccionados = this.Cursos.map((curso) => curso.id);
      } else {
        // Si el checkbox "Seleccionar Todos" está desmarcado, deseleccionar todos los niveles
        this.cursosSeleccionados = [];
      }
    },

    //-------mostrar registros de cursos de mantenimiento------------
    async getAllCursosMantenimiento() {
      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_anio_lectivo: this.datoLogin.id_ano_lectivo,
      };

      try {
        let response = await axios.post(
          "/mantenimiento/curso/adm/list/",
          params
        );
        this.Cursos = response.data;
        //console.log('cursos mantenimiento====>>'+JSON.stringify(this.Cursos))
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-------mostrar registros de cursos de mantenimiento------------
    async getAllCursosAdministrativo() {
      this.mostrarMensaje2 = false;
      this.mostrarMensaje = false;

      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_anio_lectivo: this.datoLogin.id_ano_lectivo,
      };

      try {
        let response = await axios.post(
          "/administrativo/curso/adm/list/",
          params
        );
        this.CursosAdmin = response.data;
        //console.log('====>>'+JSON.stringify(this.CursosAdmin))

        if (this.CursosAdmin.length === 0) {
          this.mostrarMensaje2 = true;
        }

        if (this.Cursos.length === 0 && this.CursosAdmin.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //--------seleccionar curso para importar ------
    seleccCurso() {
      this.dialog = true;

      // this.editedCursos.id_curso = item.id;
      // this.editedCursos.id_area = item.id_area;
      // this.editedCursos.id_grado = item.id_grado;

      // this.nombre_curso = item.desc_curso;
      // this.color_curso = item.color_curso;
      // this.icono_curso = item.icono_curso;
      // this.color_nivel = item.color_nivel;
      // this.nivel = item.nivel;
      // this.grado_curso = item.grado;
    },

    //------importar curso-----------
    async importCurso() {
      this.dialog = true;
      this.isSaving = true
      // eslint-disable-next-line no-unused-vars
      // let params = this.editedCursos;
      try {
        const cursoBase = {
          id_usuario: sessionStorage.id,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
        }


        const arrayPromesas = [] //Array de promesas de cada post de los cursos

        this.dataCursosSeleccionados.forEach(curso => {

          const params = {
            ...cursoBase,
            id_curso: curso.id,
            id_area: curso.id_area,
            id_grado: curso.id_grado

          }
          arrayPromesas.push(axios.post("administrativo/curso/", params))

        });

        await Promise.all(arrayPromesas)
        this.isSaving = false




        await this.getAllCursosMantenimiento();
        await this.getAllCursosAdministrativo();

        // si todo salió bien se vacia el array cursosSeleccionados
        this.cursosSeleccionados.splice(0)
        // dataCursosSeleccionados se vaciará tambien por ser computada

        this.dialog = false;
        //console.log(response);

        this.setEnviarMens({
          tipo: "S",
          mensaje: `¡Información importada con éxito!`,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async showmodalDelete(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.active = true;
    },
    //-- 22-05-2020. LUIS ROJAS.
    //-- METODO QUE PERMITE ELIMINAR UN CURSO DE ADMINISTRACIÓN DE COLEGIO
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    async deleteCurso() {
      try {
        //let cf = await confirm("¿Está seguro de borrar este registro?");
        //if (cf) {
        let resp = await axios.delete(
          "/administrativo/curso/" + this.confirm.id
        );
        if (JSON.stringify(resp.data.messageT) == JSON.stringify("S")) {
          this.dialog = false;
          this.getAllCursosMantenimiento();
          this.getAllCursosAdministrativo();
        }
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
        this.clear_confirm();
        //}
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>




<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}
</style>